export class UserPermission {
  area: Permission[]
  areaMap: Record<string, Permission>
}

export interface Permission {
  area: string
  action: string
  value: string
  accesslevel: number
}
